<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp29',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-29">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-29-content">
      <div
        v-for="v in moduleOption.list.slice(0, 3)"
        :key="`modules-29-${v.id}`"
        class="item"
        :style="{boxShadow: `0 4px 15px 0 ${getShadowColor(path)}`}"
        @click="onModuleItem(v)"
      >
        <el-image class="images" :src="v.photo | imgPath" alt="images" fit="cover" />
        <div class="mid-style">
          <img class="lines-img hidden" :src="require('imgs/modules/lines.png')" alt="lines">
          <span class="retanc"></span>
          <img class="lines-img" :src="require('imgs/modules/lines.png')" alt="lines">
        </div>
        <p class="title h-line-2">{{ v.headline }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-29-content {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  .item {
    width: 220px;
    height: 310px;
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .images {
    width: 200px;
    height: 138px;
    border-radius: 5px;
  }
  .title {
    width: 172px;
    font-size: 15px;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin-top: 30px;
  }
}
.mid-style {
  width: 206px;
  height: 24px;
  display: flex;
  justify-content: space-between;
  margin-top: 17px;
  .lines-img {
    width: 63px;
    height: 18px;
  }
  .hidden {
    visibility: hidden;
  }
  .retanc {
    width: 15px;
    height: 4px;
    background: #DD4135;
    margin-top: 20px;
    border-radius: 3px;
  }
}
</style>
